/**
 * Which top-level nav heading counts as "active" for the current path.
 *
 * Most headings match by URL prefix — /treatments/body-ballancer lights up
 * "Treatments". Some children live outside their parent's path (/dayclinic is
 * a Treatments item but sits at the root), so a route can list extra prefixes
 * via `matchPaths` rather than the heading going dark on its own page.
 *
 * The reverse happens too: a page can sit under a heading's path but belong to
 * a different menu (the clinic pages are /about/… but hang off Treatments), so
 * `excludePaths` stops the owning prefix claiming them and lighting two
 * headings at once.
 *
 * `activePath` is "" until the menus sync it after mount, which keeps the
 * server render stable — nothing is active during SSR.
 */
export function isNavRouteActive(
  activePath: string,
  link: string,
  matchPaths?: string[],
  excludePaths?: string[],
): boolean {
  if (activePath === "") return false;

  const under = (base: string) =>
    activePath === base || (base !== "/" && activePath.startsWith(base + "/"));

  if (excludePaths?.some(under)) return false;

  return under(link) || !!matchPaths?.some(under);
}
